import { render, staticRenderFns } from "./AxCardSearch.vue?vue&type=template&id=a4f495b0&scoped=true"
import script from "./AxCardSearch.vue?vue&type=script&lang=ts"
export * from "./AxCardSearch.vue?vue&type=script&lang=ts"
import style0 from "./AxCardSearch.vue?vue&type=style&index=0&id=a4f495b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4f495b0",
  null
  
)

export default component.exports